module.exports = __webpack_public_path__ + "static/img/3bg_16.2f0a5f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/3bg_16.png
// module id = 692
// module chunks = 1